import AppointmentsReviewNavigation from "./AppointmentsReviewNavigation";

export default AppointmentsReviewNavigation;
